export const forms = {
  shortRequired: 'Required',
  required: 'This field is required',
  password: 'The password must match validations below.',
  email: 'Enter a valid email',
  ageRequired: 'You should be at least 16 years old.',
  subscriptionRequired: 'Please, select a subscription type.',
}
